import React, {useState} from "react";
import { Button, FormGroup, Modal, Container} from "react-bootstrap";
import { Form, Checkbox ,Select } from 'antd';
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import { ImageElement,Breadcrumb, LoginHeader} from "../../components";
const handleChange = (value) => {
    console.log(`selected ${value}`);
};


function ServiceProviderMap() {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        navs:true,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1
                }
              }
          ]
      };

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Service Provider Map',
        },
    ];
    const [showRequested, setRequested] = useState(false);
    const RequestedClose = () => setRequested(false);
    const RequestedShow = () => {setRequested(true)};

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content ServiceProviderPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="Service Provider Map" breadcrumb={breadcrumb}/>
                        {/* Service Address */}
                        <div className="bookAppointment bg-white p-30 br-10 mb-3">
                            <div className="d-sm-flex align-items-center flex-wrap justify-content-between">
                                <div className="bookAppointment_left">
                                    <Button variant="primary" onClick={RequestedShow} className="btnAppointment">book appointment now</Button>
                                    <span className="font-md mt-1 d-inline-block">Or you can pick a specific technician below</span>
                                </div>
                                <div className="d-flex btns-group">
                                    <Link  to="/"  className="btn btn-info text-capitalize"><em className="gg-marker me-2" />Map</Link>
                                    <Link to="/service-provider-list" className="btn btn-light text-capitalize"><em className="gg-list me-2" />List</Link>
                                </div>   
                                            
                            </div>
                        </div>
                        <div className="serviceAddress mb-0 BookAppointmentPage">
                            <div className="d-flex align-items-center flex-wrap justify-content-between">
                                <div className="serviceAddress_left">
                                    <h2 className="text-850 font-sm">Service Address</h2>
                                    <p className="mb-0">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                                </div>
                                <div className="serviceAddress_right mt-md-0 mt-2 ms-md-auto">
                                    <div className="d-flex align-items-center">
                                        <Form>
                                            <FormGroup className="form-group d-flex align-items-center flex-wrap mb-0">
                                                <Form.Item
                                                    label="Sort By"
                                                    className="mb-0 font-md"
                                                    >
                                                    <Select
                                                        defaultValue="serviceProvider1"
                                                        onChange={handleChange}
                                                        className="w-100 ant-select-lg"
                                                        options={[
                                                            {
                                                            value: 'serviceProvider1',
                                                            label: 'All Service Provider',
                                                            },
                                                            {
                                                            value: 'serviceProvider2',
                                                            label: 'Favorite Service Provider',
                                                            },
                                                        ]}
                                                        />
                                                </Form.Item>
                                                {/* <Button variant="primary" type="submit" className="font-md">Emergency Request to all</Button> */}
                                            </FormGroup>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                            <div className="serviceAddress_map">
                                <div className="serviceAddress_map_img">
                                    <ImageElement source="map-image-2.jpg" className="img-fluid w-100 h-100"/>
                                </div>
                                <div className="serviceAddress_map_slide">
                                    <Slider {...settings}>                   
                                            <div className="appointmentList position-relative bg-white"> 
                                                <div className="appointmentList_like">
                                                    <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                                </div>
                                                <div className="appointmentList_top d-flex align-items-start">
                                                    <div className="appointmentList_top_images">
                                                        <ImageElement source="img-1.png" />
                                                    </div>
                                                    <div className="appointmentList_top_content">
                                                        <h2 className="font-md">Steven S. Hurd</h2>
                                                        <p className="">HVAC</p>
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <div className="info">
                                                                     <ul className="list-unstyled d-flex starRating mb-0">
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            {/* <li className="list-inline-item">
                                                                <div className="info">
                                                                    <em className="info_icon info_icon-blue gg-marker"/>
                                                                    <span className="info_content">2.06 mi</span>
                                                                </div>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>   
                                                <div className="appointmentList_bottom">
                                                    <Link to="/service-provider-details-miles" className="btn btn-light w-100">MORE INFO</Link>
                                                </div>  
                                            </div>
                                      
                                            <div className="appointmentList position-relative bg-white"> 
                                                <div className="appointmentList_like">
                                                    <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                                </div>
                                                <div className="appointmentList_top d-flex align-items-start">
                                                    <div className="appointmentList_top_images">
                                                        <ImageElement source="img-2.png" />
                                                    </div>
                                                    <div className="appointmentList_top_content">
                                                        <h2 className="font-md">Flynn Thwaites</h2>
                                                        <p className="">Electrician</p>
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <div className="info">
                                                                     <ul className="list-unstyled d-flex starRating mb-0">
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            {/* <li className="list-inline-item">
                                                                <div className="info">
                                                                    <em className="info_icon info_icon-blue gg-marker"/>
                                                                    <span className="info_content">2.06 mi</span>
                                                                </div>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>   
                                                <div className="appointmentList_bottom d-flex">
                                                <Link to="/service-provider-details-miles" className="btn btn-light w-100">MORE INFO</Link>
                                                </div>  
                                            </div>
                                    
                                            <div className="appointmentList position-relative bg-white"> 
                                                <div className="appointmentList_like">
                                                    <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                                </div>
                                                <div className="appointmentList_top d-flex align-items-start">
                                                    <div className="appointmentList_top_images">
                                                        <ImageElement source="img-3.png" />
                                                    </div>
                                                    <div className="appointmentList_top_content">
                                                        <h2 className="font-md">Marko Junker</h2>
                                                        <p className="">Handyman</p>
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <div className="info">
                                                                     <ul className="list-unstyled d-flex starRating mb-0">
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            {/* <li className="list-inline-item">
                                                                <div className="info">
                                                                    <em className="info_icon info_icon-blue gg-marker"/>
                                                                    <span className="info_content">2.06 mi</span>
                                                                </div>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>   
                                                <div className="appointmentList_bottom">
                                                    <Link to="/service-provider-details-miles" variant="" className="btn btn-light w-100">MORE INFO</Link>
                                                </div>   
                                            </div>
                                    
                                            <div className="appointmentList position-relative bg-white"> 
                                                <div className="appointmentList_like">
                                                    <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                                </div>
                                                <div className="appointmentList_top d-flex align-items-start">
                                                    <div className="appointmentList_top_images">
                                                        <ImageElement source="img-4.png" />
                                                    </div>
                                                    <div className="appointmentList_top_content">
                                                        <h2 className="font-md">Marco Frey</h2>
                                                        <p className="">Electrician</p>
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <div className="info">
                                                                     <ul className="list-unstyled d-flex starRating mb-0">
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            {/* <li className="list-inline-item">
                                                                <div className="info">
                                                                    <em className="info_icon info_icon-blue gg-marker"/>
                                                                    <span className="info_content">2.06 mi</span>
                                                                </div>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>   
                                                <div className="appointmentList_bottom">
                                                    <Link to="/service-provider-details-miles" className="btn btn-light w-100">MORE INFO</Link>
                                                </div>  
                                            </div>
                                      
                                            <div className="appointmentList position-relative bg-white"> 
                                                <div className="appointmentList_like">
                                                    <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                                </div>
                                                <div className="appointmentList_top d-flex align-items-start">
                                                    <div className="appointmentList_top_images">
                                                        <ImageElement source="img-1.png" />
                                                    </div>
                                                    <div className="appointmentList_top_content">
                                                        <h2 className="font-md">Steven S. Hurd</h2>
                                                        <p className="">HVAC</p>
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <div className="info">
                                                                     <ul className="list-unstyled d-flex starRating mb-0">
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            {/* <li className="list-inline-item">
                                                                <div className="info">
                                                                    <em className="info_icon info_icon-blue gg-marker"/>
                                                                    <span className="info_content">2.06 mi</span>
                                                                </div>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>   
                                                <div className="appointmentList_bottom">
                                                    <Link to="/service-provider-details-miles" className="btn btn-light w-100">MORE INFO</Link>
                                                </div>  
                                            </div>
                                        
                                            <div className="appointmentList position-relative bg-white"> 
                                                <div className="appointmentList_like">
                                                    <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                                </div>
                                                <div className="appointmentList_top d-flex align-items-start">
                                                    <div className="appointmentList_top_images">
                                                        <ImageElement source="img-1.png" />
                                                    </div>
                                                    <div className="appointmentList_top_content">
                                                        <h2 className="font-md">Steven S. Hurd</h2>
                                                        <p className="">HVAC</p>
                                                        <ul className="list-inline mb-0">
                                                            <li className="list-inline-item">
                                                                <div className="info">
                                                                     <ul className="list-unstyled d-flex starRating mb-0">
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                                                        <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                                                        <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            {/* <li className="list-inline-item">
                                                                <div className="info">
                                                                    <em className="info_icon info_icon-blue gg-marker"/>
                                                                    <span className="info_content">2.06 mi</span>
                                                                </div>
                                                            </li> */}
                                                        </ul>
                                                    </div>
                                                </div>   
                                                <div className="appointmentList_bottom">
                                                <Link to="/service-provider-details-miles" className="btn btn-light w-100">MORE INFO</Link>
                                                </div>  
                                            </div>
                                    </Slider>
                                </div>   
                            </div>
                        </div>
                        {/* Service Address */}                    
                    </Container>
                </div>
            </div>
         
            {/* Booking Requested */}
              <Modal show={showRequested} onHide={RequestedClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Requested</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p> Your provider has received the booking request and will get back to you shortly. You can check out the status of your request on the 'Your Bookings' menu item.</p>
                    </div>
                    <div className="d-flex justify-content-flex-end">    
                        <Link to="/my-bookings"  className="btn btn-primary ms-auto min-200">View BOOKING</Link>
                    </div>
                </Modal.Body>
            </Modal> 
        </>
    );
}

export default ServiceProviderMap;